
import './App.css';

import TodoCard from './components/TodoCard';

function App() {

 return (
    <div className="app">
      <div className="todo-header">
          <h1>Todo List</h1>
          <p>Add things to do</p>
      </div>
       <TodoCard  />
    </div>
  );
}

export default App;
